export const compareProductsLocalStorageKey = "comparator-products";
